// This is the 'master list' of all sports system-wide.
// The list is later filtered down on a per-locale basis.
export enum SportType {
  AUSTRALIAN_RULES = 'AUSTRALIAN_RULES',
  BASKETBALL = 'BASKETBALL',
  BOXING = 'BOXING',
  CHEERLEADING = 'CHEERLEADING',
  FLAG_FOOTBALL = 'FLAG_FOOTBALL',
  US_FOOTBALL = 'US_FOOTBALL',
  LACROSSE = 'LACROSSE',
  NETBALL = 'NETBALL',
  RUGBY = 'RUGBY',
  RUGBY_LEAGUE = 'RUGBY_LEAGUE',
  RUGBY_UNION = 'RUGBY_UNION',
  SOCCER = 'SOCCER',
  WRESTLING = 'WRESTLING',
  OTHER = 'OTHER',
}

export enum SessionType {
  TRAINING = 'TRAINING',
  GAME = 'GAME',
  OTHER = 'OTHER',
}

export enum PlayType {
  TACKLING = 'TACKLING',
  BEING_TACKLED = 'BEING_TACKLED',
  FALL = 'FALL',
  COLLISION = 'COLLISION',
  BUMPED = 'BUMPED',
  STRUCK = 'STRUCK',
  UNSURE = 'UNSURE',
  OTHER = 'OTHER',
}

export enum MechanismOfInjury {
  HEAD_TO_HEAD = 'HEAD_TO_HEAD',
  HEAD_TO_BODY = 'HEAD_TO_BODY',
  HEAD_TO_LIMB = 'HEAD_TO_LIMB',
  HEAD_TO_GROUND = 'HEAD_TO_GROUND',
  HEAD_TO_GOAL_POST = 'HEAD_TO_GOAL_POST',
  UNSURE = 'UNSURE',
  OTHER = 'OTHER',
}
